import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-outline',
  templateUrl: './mobile-outline.component.html',
  styleUrls: ['./mobile-outline.component.scss']
})
export class MobileOutlineComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
